/**
 * @Desc 关于我们数据
 * @Author mileS
 * @Date 2020-06-08 15:39
 * */

// 左侧目录导航
const navList = [
  {
    main: '1',
    title: '未来魔法校'
  },
  {
    main: '2',
    title: '政府荣誉'
  }
]

// 好未来产品在影响力机构的获奖情况
const dataList = [
  {
    content: '2019年8月，工业和信息化部、中国互联网协会在2019年中国互联网企业100强发布会暨百强企业高峰论坛上联合发布2019年中国互联网企业100强榜单。好未来集团连续两年登上中国互联网百强榜单，同时也是今年榜单中唯一一家教育企业。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8713.png'
  },
  {
    content: '2019年11月，好未来荣登《2019中国人工智能企业知识产权竞争力百强榜》十强。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8714.png'
  },
  {
    content: '2019年11月，北京市工商联发布“2019北京民营企业百强”“2019北京民营企业科技创新百强”“2019北京民营企业文化产业百强”“2019北京民营企业社会责任百强”榜单。好未来旗下学而思入围全部四个百强榜单，位列文化产业百强第3位，位列社会责任百强第93位，位列科技创新百强第11位，位列民营企业百强第22位。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8715.png'
  },
  {
    content: '2019年11月27日，在2019“回响中国”腾讯新闻教育年度盛典上，未来魔法校荣获“2019年度影响力教育品牌”。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8716.png'
  },
  {
    content: '2019年12月4日，在第十届新华网教育论坛上，未来魔法校荣获“2019年度·公信力教育品牌”奖项。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8717.png'
  },
  {
    content: '2019年12月12日，在中国互联网新闻中心（中国网）主办，中国网教育频道承办的“中国好教育”年度教育盛典活动上，未来魔法校荣获“影响力教育品牌”奖项。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8718.png'
  },
  {
    content: '2020年4月，世界计算机视觉领域知名会议CVPR2020成功举办，好未来AI工程院从全球69支团队中脱颖而出，斩获EmotioNet人脸表情识别竞赛冠军。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8719.png'
  },
  {
    content: '2020年4月8日，联合国教科文组织授予好未来教育科技集团2020年度移动学习周“人工智能与包容性”创新示范项目证书，以表彰好未来集团在使用AI和大数据提高读写能力、保护(少数民族)语言并增进包容性方面的贡献。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8720.png'
  },
  {
    content: '2020年4月14日，工信部公示了《疫情防控和复工复产复课大数据产品和解决方案名单》。作为教育领域的代表，好未来集团基于大数据的“停课不停学”在线教育解决方案榜上有名。',
    pic: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/%E5%9B%BE%E7%89%8721.png'
  }
]

// 视频地址
const video = 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/video/%E6%9C%AA%E6%9D%A5%E9%AD%94%E6%B3%95%E6%A0%A13%E5%88%86%E9%92%9F%E4%B8%9A%E5%8A%A1%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4'

export { dataList, navList, video }
